export * from './FooterTemplate';
